import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=e9e48f9e&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=e9e48f9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e48f9e",
  null
  
)

export default component.exports